import React from 'react';
import { RootStore } from '../store/root-store';

export const StoreContext = React.createContext(RootStore);

export const useStore = () => React.useContext(StoreContext);
